import { render, staticRenderFns } from "./totalPatiens.vue?vue&type=template&id=257d2e85&scoped=true"
import script from "./totalPatiens.vue?vue&type=script&lang=js"
export * from "./totalPatiens.vue?vue&type=script&lang=js"
import style0 from "./totalPatiens.vue?vue&type=style&index=0&id=257d2e85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257d2e85",
  null
  
)

export default component.exports